import { GameID, GameIDType } from '@/enums/gameId';
import { AudioService } from '@/services/AudioService';

export function handleGameSound(
  sound: boolean,
  gameId: GameIDType | undefined,
) {
  if (!sound) {
    return;
  }
  handleGameBackgroundSound(gameId);

  return () => {
    AudioService.removeAudios();
  };
}

function handleGameBackgroundSound(gameId: GameIDType | undefined) {
  if (!gameId) {
    return;
  }

  switch (gameId) {
    case GameID.Tower:
      AudioService.towerBg();
      break;
    case GameID.Limbo:
      AudioService.limboBg();
      break;
  }
}
